import {
  collection, addDoc, updateDoc, deleteDoc,
  getDocs, getDoc, doc, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export const JOB_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export async function createJob(userId, jobData) {
  const ref = await addDoc(collection(db, "users", userId, "jobs"), {
    ...jobData,
    status: jobData.status || JOB_STATUS.PENDING,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}

export async function updateJob(userId, jobId, updates) {
  await updateDoc(doc(db, "users", userId, "jobs", jobId), {
    ...updates,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteJob(userId, jobId) {
  await deleteDoc(doc(db, "users", userId, "jobs", jobId));
}

export async function getJobs(userId) {
  const snap = await getDocs(collection(db, "users", userId, "jobs"));
  const jobs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
  return jobs.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

export async function getJob(userId, jobId) {
  const snap = await getDoc(doc(db, "users", userId, "jobs", jobId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}
